import { Validator } from "./Validator";

export class RegexValidator extends Validator
{
  private _regex:RegExp;
  
  constructor( regex:RegExp )
  { 
    super();
    this._regex = regex;
  }

  validate( value:string )
  {
    return this._regex.test( value );
  }

  static get WORD()
  {
    let regex = /^\w+$/;

    return new RegexValidator( regex );
  }
  
  static get HYPHEN_WORD()
  {
    let regex = /^(\w|\-)+$/;

    return new RegexValidator( regex );
  }

  static get DUH_WORD()
  {
    let regex = /^(\w|\-|\.|\_)+$/;

    return new RegexValidator( regex );
  }

  static get BASE62()
  {
    let regex = /^[a-zA-Z0-9]+$/;

    return new RegexValidator( regex );
  }

  static get BASE64()
  {
    let regex = /^[a-zA-Z0-9\+\\/=]+$/;

    return new RegexValidator( regex );
  }

  static get BASE64URL()
  {
    let regex = /^[a-zA-Z0-9\-\_]+$/;

    return new RegexValidator( regex );
  }

  static get NUMBER()
  {
    let regex = /^(\+|\-)?((\d+)(\.\d+)?|(\.\d+))(e(\+|\-)\d+)?$/;

    return new RegexValidator( regex );
  }

  static get TIME24()
  {
    let regex = /^((?:(?:0|1)?(?:\d)|(?:2[0-3]))):(\d\d)$/;

    return new RegexValidator( regex );
  }  

  static get WEEKDAY()
  {
    let regex = /^(MON|TUE|WED|THU|FRI|SAT|SUN)$/;

    return new RegexValidator( regex );
  }

  static get DIGITS_3x2()
  {
    let regex = /^\d\d\-\d\d\-\d\d$/;

    return new RegexValidator( regex );
  }

  
}
